import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6248 5.30717C10.8506 5.537 10.8471 5.90625 10.6167 6.132L8.03483 8.66658C7.57808 9.11458 6.99008 9.338 6.4015 9.338C5.81933 9.338 5.23717 9.11867 4.78217 8.67942L3.67442 7.59033C3.44458 7.36458 3.44167 6.99533 3.66742 6.7655C3.89258 6.53508 4.263 6.53217 4.49225 6.7585L5.5965 7.84408C6.04917 8.28158 6.76375 8.27925 7.21875 7.83358L9.8 5.29958C10.0292 5.07325 10.3973 5.07733 10.6248 5.30717ZM14 7C14 10.8599 10.8599 14 7 14C3.14008 14 0 10.8599 0 7C0 3.14008 3.14008 0 7 0C10.8599 0 14 3.14008 14 7ZM12.8333 7C12.8333 3.7835 10.2165 1.16667 7 1.16667C3.7835 1.16667 1.16667 3.7835 1.16667 7C1.16667 10.2165 3.7835 12.8333 7 12.8333C10.2165 12.8333 12.8333 10.2165 12.8333 7Z"
      fill="black"
    />
  </svg>
);

const ConfirmIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ConfirmIcon;
